/**
 * Infer analytics source from the redirect URL pattern.
 * Used to tag sign-up events with the feature that originated them.
 */
export function inferAnalyticsSource(url: string | null): string {
  if (!url) return 'landing';
  if (url.includes('/a/')) return 'student_assignment';
  if (url.includes('/grading/')) return 'grading';
  if (url.includes('/assignment/')) return 'teacher_assignment';
  if (url.includes('/lesson-plan/')) return 'lesson_plan';
  return 'landing';
}
